module.exports = "<p>Under the <a href=\"https://pubmed.ncbi.nlm.nih.gov/25741868/\">ACMG/AMP Standards and Guidelines</a>, variant curators can assign specific evidence codes to variants according to their frequency in reference populations. These evidence codes contribute to the curation of the variants as Benign, Pathogenic, Likely Benign, or Likely Pathogenic.</p>";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/acmg-variant-evidence-codes-provisional-assignment.md
// module id = 1260
// module chunks = 0